import type { chains, } from "@bracket/chainography";
import { ValidChainIds, } from "../const/ValidChainIds";


/** Supported Chain Id */
export declare type ValidChainId = keyof typeof chains;


export const isValidChainId = ( value: unknown ): value is ValidChainId => {
	return typeof value === "number" && ValidChainIds.includes(value as ValidChainId);
}
